import { IClusterSchema } from '../../../common/repositories/search-offers-map/entities/cluster/ClusterSchema';
import { IGetClustersForMapResponse } from '../../../common/repositories/search-offers-map/v1/get-clusters-for-map';

/**
 * Пин нельзя отрисовать без координат, и нельзя положить в стор без geohash —
 * он служит идентификатором фичи. По контракту оба поля обязательные,
 * но если бэкенд их не пришлёт, маппер фич упадёт на всей выдаче.
 */
export function isRenderableCluster(cluster: IClusterSchema): boolean {
  const { coordinates, geohash } = cluster;

  return Boolean(geohash) && typeof coordinates?.lat === 'number' && typeof coordinates?.lng === 'number';
}

/** Считает пины в ответе: и основные, и из расширенного поиска */
export function countClusters(data: Pick<IGetClustersForMapResponse, 'filtered' | 'extended'>): number {
  return (data.filtered?.length || 0) + (data.extended?.length || 0);
}

/**
 * Отбрасывает пины, которые невозможно отрисовать.
 *
 * Лучше показать выдачу без одного битого пина, чем уронить её целиком.
 * Количество отброшенных попадает в метрику — считается как разница
 * между пришедшим и подготовленным (SLI 8).
 */
export function dropInvalidClusters(data: IGetClustersForMapResponse): IGetClustersForMapResponse {
  return {
    ...data,
    filtered: data.filtered?.filter(isRenderableCluster),
    extended: data.extended?.filter(isRenderableCluster),
  };
}
